import { useAvailabilityExceptionRequests } from './useAvailabilityExceptionRequests';
export const useAvailabilityExceptionRequest = (employeeId?: string, requestId?: string) => {
  const result = useAvailabilityExceptionRequests(employeeId);
  const request = result.requests.find(item => String(item?.id) === requestId);

  return { ...result, request };
};
